import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import _ from 'lodash';

import { analysisIsLoading, setPageName } from '../../App/AppActions';
import { setChart } from '../../../components/Filter/FilterActions';
import Filter from '../../../components/Filter/Filter';
import { getData, runAnalysis, isLoading } from '../ProcessImprovementActions';
import { getSelectionValues } from '../../../util/filterUtils';
import { trackTeamDashboardView } from '../../../util/mixpanel';

import InsightCard from '../components/InsightCard';

// Import Styles
import '../ProcessImprovement.scss';

class ProcessImprovement extends Component {
  constructor(props) {
    super(props);
    this.tooltipParentRef = React.createRef();

    this.state = {
      oct: 0,
      ct: 0,
      wip: 0,
      wipAvgAge: 0,
      showFlowMetrics: false,
      showProcessImprovement: false
    };

    props.setPageName('Process Improvement');
  }

  componentDidMount() {
    if (this.props.dashboard && this.props.dashboard._id) {
      this.props.setChart('overview');
      this.getData();
      trackTeamDashboardView('process');
    }
  }

  componentDidUpdate(prevProps) {
    this.isLoaded();   
    if (
      this.props.analysisDates &&
      this.props.analysisData && this.props.cards &&
      (prevProps.analysisDates != this.props.analysisDates ||
        prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.excludeWeekends !== this.props.excludeWeekends ||
        prevProps.workStart !== this.props.workStart ||
        prevProps.workEnd !== this.props.workEnd ||
        !_.isEqual(prevProps.holidays, this.props.holidays) ||
        prevProps.enabledColors !== this.props.enabledColors) &&
      this.props.analysisLoading === false
    ) {
      this.props.runAnalysis();
    }

    if (
      (prevProps.dataHash != this.props.dataHash ||
        prevProps.hash != this.props.hash ||
        prevProps.excludeWeekends !== this.props.excludeWeekends ||
        prevProps.workStart !== this.props.workStart ||
        prevProps.workEnd !== this.props.workEnd ||
        !_.isEqual(prevProps.holidays, this.props.holidays) ||
        prevProps.enabledColors !== this.props.enabledColors) &&
      this.props.analysisLoading
    ) {
      this.setState({ pendingUpdate: true });
    }

    if (
      prevProps.analysisLoading !== this.props.analysisLoading &&
      !this.props.analysisLoading && !this.props.analysisRunning &&
      this.state.pendingUpdate
    ) {
      this.setState({ pendingUpdate: false });
      this.props.runAnalysis();
    }
  }

  isLoaded() {
    if (
      this.props.analysisLoading &&
      !this.props.analysisRunning &&
      !this.props.ctAnalysisLoading &&
      !this.props.ctbAnalysisLoading &&
      !this.props.wipAnalysisLoading &&
      !this.props.wipAgeAnalysisLoading &&
      !this.props.thAnalysisLoading &&
      !this.props.feAnalysisLoading
    ) {
      this.props.analysisIsRunning(false);
    }
  }

  getData() {
    if (!this.props.analysisLoading) {
      this.props.analysisIsLoading(true);
      this.props.getData();
    }
  }

  tooltipWidth() {
    return this.tooltipParentRef.current ? `${this.tooltipParentRef.current.offsetWidth - 5}px` : 'auto';
  }

  render() {
    const { queueLists, allQueueLists } = this.props;
    const showFlowEfficiency = getSelectionValues(queueLists, allQueueLists).length < allQueueLists.length;
    const totalItems = this.props.cards ? this.props.cards.length : 0;

    const tresholdsCalculationsTooltip = (
      <Tooltip id="tresholdsTooltip" className="tooltip_white calculate_info" style={{ width: this.tooltipWidth() }}>
        Your thresholds are set by analyzing a time-ordered sequence of data, using between 4 to 20 data points (with 20
        as the default).
        <br></br>
        <br></br>
        To flag a low or high status for your flow metrics, we look for a signal—a significant deviation from your
        typical process behavior.
        <br></br>
        <br></br>
        When a signal is detected, the benchmarks are frozen, and no new data points are included. Once at least 4 new
        data points are available, they are used to establish a new baseline.
        <br></br>
        <br></br>
        We use last three months data in this analysis.
      </Tooltip>
    );

    return (
      <div className="background_gray overview_page">
        <Helmet title={`Process Improvement${this.props.dashboard ? ' | ' + this.props.dashboard.name : ''}`} />
        {this.props.cards && !this.props.analysisLoading && (
          <Filter isOverview isProcessImprovement colors disabledLists={['todo']} />
        )}
        <div className="overview">
          <div className="overview-header">
            <div className="overview-header-right-elements" ref={this.tooltipParentRef}>
              <OverlayTrigger
                overlay={tresholdsCalculationsTooltip}
                delay={{ show: 10, hide: 1000 }}
                placement="bottom"
                trigger={['hover', 'focus', 'click']}
              >
                <span className="calculate_tresholds">
                  <span className="more_info" />
                  How we calculate your thresholds
                </span>
              </OverlayTrigger>
            </div>
          </div>

          <InsightCard
            app={this.props.app}
            ctAnalysis={this.props.ctAnalysis}
            ctAnalysisLoading={this.props.ctAnalysisLoading}
            wipAgeAnalysis={this.props.wipAgeAnalysis}
            wipAgeAnalysisLoading={this.props.wipAgeAnalysisLoading}
            wipAnalysis={this.props.wipAnalysis}
            wipAnalysisLoading={this.props.wipAnalysisLoading}
            ctbAnalysis={this.props.ctbAnalysis}
            ctbAnalysisisLoading={this.props.ctbAnalysisisLoading}
            thAnalysis={this.props.thAnalysis}
            thAnalysisisLoading={this.props.thAnalysis}
            feAnalysis={this.props.feAnalysis}
            feAnalysisisLoading={this.props.feAnalysisisLoading}
            hasFlowEfficiency={showFlowEfficiency}
            dashboardName={this.props.dashboard ? this.props.dashboard.name : ''}
            dashboardId={this.props.dashboard ? this.props.dashboard._id : ''}
            userSubscription={this.props.user ? this.props.user.status : ''}
          />
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setChart: chart => dispatch(setChart(chart)),
    getData: () => dispatch(getData()),
    analysisIsLoading: loading => dispatch(analysisIsLoading(loading)),
    analysisIsRunning: loading => dispatch(isLoading(loading)),
    setPageName: name => dispatch(setPageName(name)),
    runAnalysis: () => dispatch(runAnalysis())
  };
};

const mapStateToProps = state => {
  return {
    app: state.app.app,
    user: state.auth.user,
    enabledColors: state.filters.enabledColors,
    timePrecision: state.filters.timePrecision,
    excludeWeekends: state.filters.excludeWeekends,
    workStart: state.filters.workStart,
    workEnd: state.filters.workEnd,
    holidays: state.filters.holidays,
    queueLists: state.filters.overview.selectedQueueLists,
    allQueueLists: state.filters.allQueueLists,
    hash: state.filters.overview.hash,
    analysisRunning: state.process.analysisRunning,
    analysisLoading: state.app.analysisLoading,   
    dataHash: state.app.analysisDataHash,
    analysisData: state.app.analysisData,
    dashboard: state.dashboards.selected,
    cards: state.app.analysisData.cards,
    analysisDates: state.filters.analysisDates,
    ctAnalysis: state.process.ctAnalysis,
    ctAnalysisLoading: state.process.ctAnalysisLoading,
    wipAgeAnalysis: state.process.wipAgeAnalysis,
    wipAgeAnalysisLoading: state.process.wipAgeAnalysisLoading,
    wipAnalysis: state.process.wipAnalysis,
    wipAnalysisLoading: state.process.wipAnalysisLoading,
    ctbAnalysis: state.process.ctbAnalysis,
    ctbAnalysisLoading: state.process.ctbAnalysisLoading,
    thAnalysis: state.process.thAnalysis,
    thAnalysisLoading: state.process.thAnalysisLoading,
    feAnalysis: state.process.feAnalysis,
    feAnalysisLoading: state.process.feAnalysisLoading
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessImprovement);
